import React from 'react';

import { PodNftCard } from '@pkg/components';
import { useMediaQuery } from '@pkg/providers';

import { type ItemData } from '../../hooks';

import { CardGrid } from './components';

export interface ModernGridProps {
    items: ItemData[];
}

export function ModernGrid({ items = [] }: ModernGridProps) {
    const { quadHdY } = useMediaQuery();
    const compact = !quadHdY;

    const modernItems = items.map(({ item, owner, lastSale, currencyConversionRate }) => {
        return (
            <CardGrid.Item key={`FloorGame-Item-${item.id}`}>
                <PodNftCard
                    item={item}
                    owner={owner}
                    currencyConversionRate={currencyConversionRate}
                    lastSale={lastSale}
                    compact={compact}
                />
            </CardGrid.Item>
        );
    });

    return <CardGrid compact={compact}>{modernItems}</CardGrid>;
}
